import ActionIcons from "../actionIcons";
export const getHeaderConfig = (loadData, filters) => [
  {
    label: "Code",
    id: "code",
  },
  {
    label: "Description",
    id: "description",
  },
  {
    label: "Actions",
    id: "actions",
    render: (data) => {
      return (
        <ActionIcons
          loadData={loadData}
          filters={filters}
          type="complaint"
          id={data.id}
          Code={data.code}
          Description={data.description}
        />
      );
    },
  },
];
